export default {
  created () {
    this.config = this.$options.config
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-fraction-grid/utils/init-config.js